module.exports = __webpack_public_path__ + "img/fjellskredovervaakning.afd216a8.jpg";